import React, { memo, useEffect, useState } from "react";
import { getSchedulesForCallFlow } from "../../apiclients/streamsapi_bridge";
import CFNodeUI from "./NodeUI";
import Loader from "./Loader";
import DropDown from "./DropDown";

function sortSchedules(schedules) {
  return [...schedules].sort((a, b) => {
    if (a.schedule_type === 2 && b.schedule_type !== 2) return -1;
    if (a.schedule_type !== 2 && b.schedule_type === 2) return 1;
    return 0;
  });
}

function excludeSelectedFromList(list, selectedObject) {
  if (!selectedObject || !selectedObject.schedule_id) return list;
  return list.filter(
    (item) => item.schedule_id !== selectedObject.schedule_id
  );
}

export default memo(({ data, isConnectable }) => {
  const [locations, setLocations] = useState([]);
  const [isloading, setIsloading] = useState(false);

  function processClick(value, tlocations) {
    if (value === "Create New") {
      data.actionExecutor({ action: 1 });
      return;
    }
    if (!tlocations) {
      tlocations = locations;
    }
    let tloc = tlocations.filter((loc) => loc.name === value)[0];
    if (!tloc) {
      tloc = {};
      tloc.alltime = false;
    }
    let temphanldes = [];
    if (tloc.schedules && tloc.schedules.length > 0) {
      tloc.schedules &&
        tloc.schedules.map((sh, index) => {
          temphanldes = [
            ...temphanldes,
            { id: index + 1, name: sh, label: sh },
          ];
        });
    } else {
      temphanldes = [{ id: "1", name: "24/7", label: "24/7" }];
    }
    data.selected_object_old = data.selected_object
      ? data.selected_object
      : {
          label: value,
          value: tloc.schedule_id ? tloc.schedule_id : "",
          schedule_id: tloc.schedule_id ? tloc.schedule_id : "",
          schedule_type: tloc.schedule_type ? tloc.schedule_type : "1",
          code: tloc.schedule_id,
          info: tloc,
        };
    data.selected_object = {
      label: value,
      value: tloc.schedule_id ? tloc.schedule_id : "",
      schedule_id: tloc.schedule_id ? tloc.schedule_id : "",
      schedule_type: tloc.schedule_type ? tloc.schedule_type : "1",
      code: tloc.schedule_id,
      info: tloc,
    };

    console.log("=============================================222222");
    console.log(temphanldes);
    data.handles = temphanldes;

    data.actionExecutor({ action: 2, value: temphanldes });
    data.actionExecutor({ action: 7 });
  }

  const openLocation = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log(data.selected_object);
    if (data.selected_object && data.selected_object.schedule_type == 2) {
      data.actionExecutor({ action: 1, value: data.selected_object });
    } else {
      console.log("in else....");
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const halfWidth = screenWidth / 1.5;
      const halfHeight = screenHeight / 1.5;
      const windowFeatures = `width=${halfWidth},height=${halfHeight},top=0,left=0`;
      localStorage.setItem(
        "locScheduleInfo",
        JSON.stringify(data.selected_object.code)
      );
      const locWindow = window.open("/locDetails", "", windowFeatures);
      window.receiveMessageFromChild = (nodeFlag) => {
        if (nodeFlag === 1) {
          data.actionExecutor({ action: 17, value: "Location" });
          console.log("Received message from child:", nodeFlag);
        }
      };
    }
  };

  async function getLocations() {
    setIsloading(true);
    let getcallflowid = localStorage.getItem("veditor_cfid");
    // Parse the stringified JSON to an object
    let callFlowObject = getcallflowid ? JSON.parse(getcallflowid) : null;
    let cfid = callFlowObject ? callFlowObject.call_flow_id : "";
    console.log("cfid:::::", JSON.stringify(cfid));
    const response = await getSchedulesForCallFlow(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      cfid
    );
    console.log("All schedule data :::", JSON.stringify(response));
    const tdata = await response.json();
    if (!tdata?.message) {
      const hasCustomSchedule = tdata?.all_schedules?.some(item => item.schedule_type === 2);
      const rawList = hasCustomSchedule
        ? tdata.all_schedules
        : [{ id: -1, name: "Create New" }, ...tdata.all_schedules];
      setLocations(sortSchedules(excludeSelectedFromList(rawList, data.selected_object)));
    }
    const storedState = localStorage.getItem("callflowState");
    console.log("storedState");
    console.log(storedState);
    if (storedState) {
      console.log("came here..");
      console.log(data.selected_object);
      if (!data.selected_object || !data.selected_object.label) {
        console.log("in if");
        processClick(JSON.parse(storedState).callflow.location_name, [
          { id: -1, name: "Create New" },
          ...tdata.all_schedules,
        ]);
      }
    }
    setIsloading(false);
  }
useEffect(() =>{
    const fetchSchedules = async () =>{
      if (data && data.selected_object) {
        try {
          let getcallflowid = localStorage.getItem("veditor_cfid");
          let callFlowObject = getcallflowid ? JSON.parse(getcallflowid) : null;
          let cfid = callFlowObject ? callFlowObject.call_flow_id : "";
  
          console.log("cfid:::::", JSON.stringify(cfid));
  
          const response = await getSchedulesForCallFlow(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            cfid
          );
  
          console.log("All schedule data :::", JSON.stringify(response));
  
          const tdata = await response.json();
  
          if (!tdata?.message) {
            const hasCustomSchedule = tdata?.all_schedules?.some(
              (item) => item.schedule_type === 2
            );
            const rawList = hasCustomSchedule
              ? tdata.all_schedules
              : [{ id: -1, name: "Create New" }, ...tdata.all_schedules];
            setLocations(sortSchedules(excludeSelectedFromList(rawList, data.selected_object)));
          }
        } catch (err) {
          console.error("Failed to fetch schedules:", err);
        }
      }
    };
  
    fetchSchedules();
  }, [data]);
  
  useEffect(() => {
    if (!data.selected_object) {
      data.selected_object = {};
    }
    getLocations();
    if (!data.handles) {
      data.handles = [{ id: "1", name: "24/7", label: "24/7" }];
    }
    /**
     * updating Node for Handles
     */
    setTimeout(() => {
      data.actionExecutor({ action: 0 });
    }, 500);
  }, []);

  function onDelete(id) {
    data.onDelete(id);
  }
  const deleteHandle = (handles) => {};
  const onHandleUpdate = (handles) => {
    data.handles = handles;
  };

  return (
    <>
      <CFNodeUI
        headerClass="scheduleNodeHeader"
        data={data}
        targethandles={data.handles}
        deletable={false}
        onDelete={onDelete}
        isConnectable={isConnectable}
        onHandleDelete={deleteHandle}
        onHandleUpdate={onHandleUpdate}
        bodyContnent={
          <>
            <DropDown
              data={locations}
              onLinkClick={openLocation}
              onSelect={processClick}
              placeholder={"Choose Location"}
              nodedata={data}
              title={
                data.selected_object
                  ? data.selected_object.label
                  : "Choose Schedule"
              }
              showhyperlink={true}
              skipFlag={data.skipConfirmation ? data.skipConfirmation : false}
              itemContent={(row) =>
                row.schedule_type === 2 ? (
                  <p className="custom_schedule_dropdown">{row.name} (Custom)</p>
                ) : (
                  row.name
                )
              }
            ></DropDown>
          </>
        }
        targetNode={false}
      />
      <Loader isloading={isloading} />
    </>
  );
});
